import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';

import NavData from '@/config/data/nav/nav_data.json';

function CommonSearchForm({ mode, className }) {
  const history = useHistory();
  const inputRef = useRef();

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const searchText = formData.get('qt');

    if (searchText) {
      history.push({ pathname: NavData['SEARCH_MAIN'].path, search: `?qt=${searchText}` });
      return;
    }

    mode === 'ko' ? alert('검색어를 입력 해 주세요') : alert('Please enter a search word');
    inputRef.current.focus();
  };

  return (
    <form className={`header-search ${className}`} onSubmit={handleSearchSubmit}>
      <input type="search" ref={inputRef} name="qt" />
      <button type="submit" value="search button">
        <span className="icon-search" />
      </button>
    </form>
  );
}

export default CommonSearchForm;
